var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    staticClass: "inner-form",
    attrs: {
      "id": "register-form",
      "name": "Sign-In",
      "data-name": "Sign In",
      "method": "get"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.register.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "callout-box-wrapper margin-bottom-small"
  }, [_vm._m(0), _vm.errorArray.length > 0 ? _c('div', _vm._l(_vm.errorArray, function (error, index) {
    return _c('p', {
      key: index,
      staticClass: "red--text"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  }), 0) : _c('p', {
    staticClass: "main-paragraph text-white-opacity-strong"
  }, [_vm._v(" Pre registráciu vypíšte údaje nižšie. ")])]), _c('div', {
    staticClass: "inner-input",
    attrs: {
      "data-w-id": "04ad70bc-eea8-0271-fb2c-c6b2beee4041"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.firstName,
      expression: "firstName"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "maxlength": "256",
      "placeholder": "Meno",
      "id": "Meno",
      "required": ""
    },
    domProps: {
      "value": _vm.firstName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.firstName = $event.target.value;
      }
    }
  })]), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _c('div', {
    staticClass: "inner-input",
    attrs: {
      "data-w-id": "04ad70bc-eea8-0271-fb2c-c6b2beee4041"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.lastName,
      expression: "lastName"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "maxlength": "256",
      "placeholder": "Priezvisko",
      "id": "Priezvisko",
      "required": ""
    },
    domProps: {
      "value": _vm.lastName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.lastName = $event.target.value;
      }
    }
  })]), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _c('div', {
    staticClass: "inner-input",
    attrs: {
      "data-w-id": "04ad70bc-eea8-0271-fb2c-c6b2beee4041"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "type": "email",
      "maxlength": "256",
      "name": "Email",
      "data-name": "Email",
      "placeholder": "Zadajte email",
      "id": "Email",
      "required": ""
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.email = $event.target.value;
      }
    }
  })]), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _c('div', {
    staticClass: "inner-input margin-bottom-xsmall",
    attrs: {
      "data-w-id": "04ad70bc-eea8-0271-fb2c-c6b2beee4045"
    }
  }, [_c('div', {
    staticClass: "passw-input"
  }, [[_vm.typePassword ? 'password' : 'text'] === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password1,
      expression: "password1"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "maxlength": "256",
      "name": "Heslo1",
      "placeholder": "Zadajte heslo",
      "id": "Heslo1",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password1) ? _vm._i(_vm.password1, null) > -1 : _vm.password1
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.register.apply(null, arguments);
      },
      "change": function change($event) {
        var $$a = _vm.password1,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password1 = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.password1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.password1 = $$c;
        }
      }
    }
  }) : [_vm.typePassword ? 'password' : 'text'] === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password1,
      expression: "password1"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "maxlength": "256",
      "name": "Heslo1",
      "placeholder": "Zadajte heslo",
      "id": "Heslo1",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password1, null)
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.register.apply(null, arguments);
      },
      "change": function change($event) {
        _vm.password1 = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password1,
      expression: "password1"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "maxlength": "256",
      "name": "Heslo1",
      "placeholder": "Zadajte heslo",
      "id": "Heslo1",
      "required": "",
      "type": [_vm.typePassword ? 'password' : 'text']
    },
    domProps: {
      "value": _vm.password1
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.register.apply(null, arguments);
      },
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.password1 = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "icon-wrapper",
    on: {
      "click": function click($event) {
        _vm.typePassword = !_vm.typePassword;
      }
    }
  }, [_vm.typePassword ? _c('svg', {
    staticClass: "bi bi-eye-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
    }
  })]) : _c('svg', {
    staticClass: "bi bi-eye-slash-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"
    }
  }), _c('path', {
    attrs: {
      "d": "M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"
    }
  })])])])]), _c('div', {
    staticClass: "inner-input margin-bottom-xsmall",
    attrs: {
      "data-w-id": "04ad70bc-eea8-0271-fb2c-c6b2beee4045"
    }
  }, [_c('div', {
    staticClass: "passw-input"
  }, [[_vm.typePassword ? 'password' : 'text'] === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password2,
      expression: "password2"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "maxlength": "256",
      "name": "Heslo2",
      "placeholder": "Zopakujte heslo",
      "id": "Heslo2",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password2) ? _vm._i(_vm.password2, null) > -1 : _vm.password2
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.register.apply(null, arguments);
      },
      "change": function change($event) {
        var $$a = _vm.password2,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password2 = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.password2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.password2 = $$c;
        }
      }
    }
  }) : [_vm.typePassword ? 'password' : 'text'] === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password2,
      expression: "password2"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "maxlength": "256",
      "name": "Heslo2",
      "placeholder": "Zopakujte heslo",
      "id": "Heslo2",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password2, null)
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.register.apply(null, arguments);
      },
      "change": function change($event) {
        _vm.password2 = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password2,
      expression: "password2"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "maxlength": "256",
      "name": "Heslo2",
      "placeholder": "Zopakujte heslo",
      "id": "Heslo2",
      "required": "",
      "type": [_vm.typePassword ? 'password' : 'text']
    },
    domProps: {
      "value": _vm.password2
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.register.apply(null, arguments);
      },
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.password2 = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "icon-wrapper",
    on: {
      "click": function click($event) {
        _vm.typePassword = !_vm.typePassword;
      }
    }
  }, [_vm.typePassword ? _c('svg', {
    staticClass: "bi bi-eye-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
    }
  })]) : _c('svg', {
    staticClass: "bi bi-eye-slash-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"
    }
  }), _c('path', {
    attrs: {
      "d": "M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"
    }
  })])])])]), _c('div', {
    staticClass: "inner-input",
    attrs: {
      "data-w-id": "04ad70bc-eea8-0271-fb2c-c6b2beee4041"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.token,
      expression: "token"
    }],
    staticClass: "text-field-3 dark w-input",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000",
      "data-aos-once": "true",
      "maxlength": "256",
      "placeholder": "Token",
      "id": "Token",
      "required": ""
    },
    domProps: {
      "value": _vm.token
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.token = $event.target.value;
      }
    }
  })])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "logo-footer margin-bottom-small w-inline-block",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "loading": "lazy",
      "src": require("@/images/Bankari-logo-transparent-extrabold.svg"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }